function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  x2: 0.5,
  y1: 0.999,
  y2: -0.001,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.251
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.122
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.102
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 0.501,
  x2: 0.501,
  y1: 1.001,
  y2: 0.001,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 0.832,
  x2: 0.164,
  y1: 0.148,
  y2: 0.893,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006dc9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#afc0e0}.cls-2{fill:#fff}.cls-2,.cls-8{opacity:.2}.cls-13,.cls-3{opacity:.1}.cls-4{fill:#e3e8f4}.cls-10,.cls-8{fill:#1fa0ff}.cls-6{opacity:.4}.cls-13,.cls-9{fill:#f55f44}.cls-10,.cls-9{opacity:.05}.cls-11{fill:#535461;opacity:.25}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Rocket"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-52",
  transform: "rotate(34 29.631 206.003)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M14.4 19.819a5.143 5.143 0 0 0-1.016.293C6.074 23.058 6.2 42.344 6.2 42.344H4.044A138.337 138.337 0 0 0 .415 22.259C-2.244 11.635 8.663 2.113 10.878.308c.249-.2.387-.308.387-.308C22.251 4.076 14.4 19.819 14.4 19.819z",
  className: "cls-1",
  transform: "translate(.064 58.369)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  d: "M12.162.332c-.256-.118-.519-.23-.8-.332l-.391.308C8.738 2.113-2.264 11.636.419 22.26a136.586 136.586 0 0 1 3.654 20.084h1.22a136.142 136.142 0 0 0-3.661-20.086C-1.039 11.682 9.856 2.2 12.162.332z",
  className: "cls-2",
  transform: "translate(.105 58.383)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  d: "M16.7 22.262a136.8 136.8 0 0 0-3.625 20.083h-2.153s.135-20.157-7.685-22.407a4.237 4.237 0 0 0-.516-.122S-5.136 4.073 5.853 0c0 0 .111.083.312.246C8.2 1.892 19.391 11.515 16.7 22.262z",
  className: "cls-1",
  transform: "translate(34.296 58.372)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-4",
  d: "M3.558 19.86a5.232 5.232 0 0 0-1.027.293A134.377 134.377 0 0 1 0 .308C.252.107.392 0 .392 0 11.5 4.082 3.558 19.86 3.558 19.86z",
  className: "cls-3",
  transform: "translate(11.031 58.318)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-5",
  d: "M6.306.241a121.622 121.622 0 0 1-2.994 19.686 4.42 4.42 0 0 0-.528-.122S-5.254 4.071 5.988 0c-.005-.005.112.078.318.241z",
  className: "cls-3",
  transform: "translate(34.144 58.463)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-6",
  d: "M25.164 81.038q-1.147 4.538-2.689 9.312s-4.878 5.1-16.66 0a89.809 89.809 0 0 1-2.472-8.985C.494 68.927-2.924 45.224 4.358 20.878A90.747 90.747 0 0 1 13.532 0s6.222 7.163 10.788 20.874 7.473 33.97.844 60.164z",
  className: "cls-4",
  transform: "translate(11.127 .107)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  cx: 9.797,
  cy: 9.85,
  className: "cls-1",
  rx: 9.797,
  ry: 9.85,
  transform: "translate(15.886 30.535)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-7",
  fill: "#1fa0ff",
  d: "M13.739 6.906a6.91 6.91 0 0 1-3.931 6.243 6.84 6.84 0 0 1-7.294-.9 6.965 6.965 0 0 1-1.287-1.4 6.806 6.806 0 0 1-.444-.733A6.924 6.924 0 0 1 0 6.906v-.165A6.909 6.909 0 0 1 5 .253 7.069 7.069 0 0 1 6.659 0h.206a6.851 6.851 0 0 1 4.86 2.021 6.926 6.926 0 0 1 2.014 4.885z",
  transform: "translate(18.814 33.478)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-8",
  d: "M19.82 20.947a21.634 21.634 0 0 1-19.82 0A91.578 91.578 0 0 1 9.113 0s6.175 7.188 10.707 20.947z",
  className: "cls-1",
  transform: "translate(15.527 .211)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-9",
  d: "M21.847 0q-.779 3.067-1.736 6.238-.454 1.513-.957 3.05s-4.882 5.085-16.676 0c0 0-.383-1.078-.957-3.05C1.092 4.749.558 2.752 0 .323A29.6 29.6 0 0 0 10.622 2.2 29.272 29.272 0 0 0 21.847 0z",
  className: "cls-1",
  transform: "translate(14.511 81.212)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-10",
  d: "M18.468 0q-.451 1.484-.951 2.992s-4.851 4.987-16.567 0C.951 2.992.57 1.934 0 0c0 0 11.941 3.391 18.468 0z",
  className: "cls-4",
  transform: "translate(15.999 87.524)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-11",
  d: "M5.075.255L5.06.266 0 6.794v.166a6.943 6.943 0 0 0 .794 3.23L6.757 0z",
  className: "cls-2",
  transform: "translate(18.703 33.362)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-12",
  d: "M5.405.516l-4.11 6.277A7.07 7.07 0 0 1 0 5.36L4.9 0z",
  className: "cls-2",
  transform: "translate(19.837 38.983)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-13",
  d: "M8.455 90.351a89.98 89.98 0 0 1-2.471-8.985C3.135 68.925-.282 45.221 7 20.873a91.111 91.111 0 0 1 8.033-18.911C14.108.663 13.531 0 13.531 0a90.76 90.76 0 0 0-9.174 20.873C-2.923 45.221.494 68.925 3.343 81.366a89.98 89.98 0 0 0 2.471 8.985c4.654 2.012 8.229 2.434 10.853 2.209a25.791 25.791 0 0 1-8.212-2.209z",
  className: "cls-2",
  transform: "translate(11.23 .14)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-72",
  transform: "translate(168.376 52.991)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  className: "cls-6"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path-14",
  fill: "url(#linear-gradient)",
  d: "M6.061 1.354a3.418 3.418 0 0 0-1-.9A3.344 3.344 0 0 0 1.2.8a3.438 3.438 0 0 0-1 3.777 3.377 3.377 0 0 0 3.165 2.248c.071 0 .143 0 .214-.007a3.374 3.374 0 0 0 2.853-1.981 3.444 3.444 0 0 0-.373-3.48z",
  transform: "translate(.033 .004)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path-15",
  d: "M6.4 3.19a3.194 3.194 0 0 1-3 3.185c-.067 0-.135.007-.2.007A3.192 3.192 0 1 1 4.8.427a3.227 3.227 0 0 1 .953.842A3.169 3.169 0 0 1 6.4 3.19z",
  className: "cls-8",
  transform: "translate(.221 .228)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-16",
  d: "M.805.025a3.726 3.726 0 0 0-.49.234.755.755 0 0 0-.262.215.257.257 0 0 0-.006.3A.5.5 0 0 0 .416.9a.747.747 0 0 0 .672-.2l.283-.235c.1-.08.206-.191.163-.3A.286.286 0 0 0 1.3.017 1.088 1.088 0 0 0 .589.13",
  className: "cls-9",
  transform: "translate(1.765 1.368)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-2",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-10",
  transform: "translate(.689 3.818)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-3",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-10",
  transform: "translate(3.998 2.678)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-17",
  d: "M1.765.806a.843.843 0 0 1-.852.789A.856.856 0 0 1 0 .861.824.824 0 0 1 .766 0a3.3 3.3 0 0 1 1 .806z",
  className: "cls-10",
  transform: "translate(4.191 .684)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-18",
  d: "M2.426.289A3.23 3.23 0 0 1 .006 1.6C0 1.553 0 1.51 0 1.466A1.462 1.462 0 0 1 .837.156a1.567 1.567 0 0 1 1.589.133z",
  className: "cls-9",
  transform: "translate(3.529 5.014)"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-4",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-11",
  transform: "translate(152.991 77.778)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-5",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-11",
  transform: "translate(0 107.692)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-6",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-11",
  transform: "translate(198.291 113.675)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-7",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-11",
  transform: "translate(55.556 59.829)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-8",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-11",
  transform: "translate(90.598 42.735)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-9",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-11",
  transform: "translate(19.658 85.47)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-19",
  d: "M1.709.709H1V0H.71v.709H0V1h.71v.709H1V1h.71z",
  className: "cls-11",
  transform: "translate(181.197 86.325)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-20",
  d: "M1.709.709H1V0H.71v.709H0V1h.71v.709H1V1h.71z",
  className: "cls-11",
  transform: "translate(198.291 51.282)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-21",
  d: "M1.709.71H1V0H.71v.71H0V1h.71v.71H1V1h.71z",
  className: "cls-11",
  transform: "translate(124.786 31.624)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-22",
  d: "M1.709.709H1V0H.709v.709H0V1h.709v.709H1V1h.711z",
  className: "cls-11",
  transform: "translate(169.231 81.197)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-23",
  d: "M1.709.709H1V0H.711v.709H0V1h.711v.709H1V1h.709z",
  className: "cls-11",
  transform: "translate(131.624 115.385)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-24",
  d: "M1.709.709H1V0H.71v.709H0V1h.71v.711H1V1h.71z",
  className: "cls-11",
  transform: "translate(64.103 32.479)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-25",
  d: "M1.709.709H1V0H.71v.709H0V1h.71v.711H1V1h.71z",
  className: "cls-11",
  transform: "translate(92.308)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-26",
  d: "M1.709.71H1V0H.709v.71H0V1h.709v.71H1V1h.711z",
  className: "cls-11",
  transform: "translate(41.88 100)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  className: "cls-6",
  transform: "translate(44.444 76.068)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path-27",
  fill: "url(#linear-gradient-2)",
  d: "M8.237 1.828A4.616 4.616 0 0 0 6.875.621a4.574 4.574 0 1 0-2.287 8.527h.289a4.574 4.574 0 0 0 3.36-7.318z",
  transform: "translate(.062 .21)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path-28",
  d: "M8.547 4.71A4.537 4.537 0 0 1 4.542 9.4h-.27A4.317 4.317 0 0 1 .258 6.307 5.008 5.008 0 0 1 1.527 1.1 3.97 3.97 0 0 1 6.41.628a4.487 4.487 0 0 1 1.274 1.239 4.99 4.99 0 0 1 .863 2.843z",
  className: "cls-8",
  transform: "translate(44.444 76.923)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-29",
  d: "M.9.062A3.77 3.77 0 0 0 .345.5a1.128 1.128 0 0 0-.291.4.764.764 0 0 0 0 .563.436.436 0 0 0 .41.225.644.644 0 0 0 .736-.377l.315-.434A.753.753 0 0 0 1.7.313a.371.371 0 0 0-.266-.282.8.8 0 0 0-.784.212",
  className: "cls-13",
  transform: "translate(46.154 77.778)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-10",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-13",
  transform: "translate(44.872 82.479)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval-11",
  cx: 0.855,
  cy: 0.855,
  r: 0.855,
  className: "cls-13",
  transform: "translate(49.573 80.342)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-30",
  d: "M1.709.862A.855.855 0 1 1 .741 0a3.292 3.292 0 0 1 .968.862z",
  className: "cls-13",
  transform: "translate(49.573 77.778)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-31",
  d: "M3.4.314A5.051 5.051 0 0 1 0 1.709v-.138A1.594 1.594 0 0 1 1.179.166a2.8 2.8 0 0 1 2.24.148z",
  className: "cls-13",
  transform: "translate(48.718 83.761)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3-2",
  fill: "url(#linear-gradient-3)",
  d: "M41.1 1.356q3.829 9.015 10.645 10.152t-19.1 34.037L8.088 52.9q-18.693 19.489 5.821-20.042T41.1 1.356z",
  transform: "rotate(-2 3067.87 -1131.332)"
}));

function SvgUpgradeRequired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Rocket_ic",
    width: 200,
    height: 166,
    viewBox: "0 0 200 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeRequired);
export default __webpack_public_path__ + "static/media/upgrade-required.971bc56d38f133689c4d434a58f4c717.svg";
export { ForwardRef as ReactComponent };